<template>
    <span
        :class="`mdi mdi-${name}`"
        :style="`width: ${size}px; height: ${size}px; font-size: ${size}px;`"
    />
</template>

<script>
export default {
    name: 'DIcon',
    props: {
        name: {
            type: String,
            required: true,
            default () {
                return 'cog'
            }
        },
        size: {
            type: Number,
            required: false,
            default () {
                return 20
            },
            validator: value => value === '' || !isNaN(Number.parseInt(value))
        }
    }
}
</script>

<style scoped>
    .mdi {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
</style>
